module.exports = __webpack_public_path__ + "static/media/na.5ba3d655.svg";